export const ColorDict = {
  Drawdown  : "#E5E0D7",
  Repayment : "#B4F1DB",
}
